'use client';

import { atom } from 'jotai';

import type { AllExperiments } from '../Entities/Experiments.entities';

const experimentsAtom = atom<AllExperiments>([]);

export { experimentsAtom };
